import React, { useEffect, useState } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { Button, TableContainer } from "../../../styles";
import { ICON_BIN, ICON_PEN, ICON_PLUS } from "../../../utils/icons";
import DeleteModal from "../DeleteModal";
import AddSupplier from "./AddSupplier";
import EditSupplier from "./EditSupplier";
import { useSupplierContext } from "../../../context/supplier_context";
import MiniLoader from "../../../utils/MIniLoader";
import CustomTable from "../../../utils/CustomTable";

export default function AllSuppliers() {

      const [supplierData, setSupplierData] = useState('');

      const {
            openAddSupplier,
            openEditSupplier,
            supplierLoading, getSupplierData, allSuppliers
      } = useSupplierContext();

      function openEditModal(item) {
            setSupplierData(item);
            openEditSupplier();
      }

      useEffect(() => {
            const supplier = allSuppliers?.map((item, i) => {

                  const { id, name, phone, real_date, mail } = item;
                  const payload = { sid: id };

                  return (
                        {
                              sn: 1 + i,
                              name,
                              phone: phone || 'Nil',
                              mail: mail || 'Nil',
                              real_date,
                              action:
                                    <h6 className="d-flex fit-content border-bottom pointer border-success green-text text-center"
                                          onClick={() => openEditModal(item)}
                                    >
                                          {ICON_PEN}
                                    </h6>
                              ,
                              delete:
                                    <DeleteModal
                                          payload={payload}
                                          name={name}
                                          url={'deleteSupplier'}
                                          getDataFn={getSupplierData}
                                          dataName={'Supplier'}
                                    >
                                          <h6 className="d-flex fit-content  border-bottom pointer border-danger red-text text-center"
                                          >
                                                {ICON_BIN}
                                          </h6>
                                    </DeleteModal>
                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  rows:
                        supplier
            });
      }, [allSuppliers]);

      useEffect(() => {
            getSupplierData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                  },
                  {
                        label: "Name",
                        field: "name",
                        width: 270,
                  },
                  {
                        label: "Phone",
                        field: "phone",
                        width: 270,
                  },
                  {
                        label: "Email",
                        field: "mail",
                        width: 270,
                  },

                  {
                        label: "Date Added",
                        field: "real_date",
                        width: 200,
                  },
                  {

                        label: 'Action',
                        field: "action",
                        width: 200,
                  },
                  {
                        label: 'Delete',
                        field: "delete",
                        width: 200,
                  },
            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Supplier"}
                              loading={supplierLoading}
                              getData={getSupplierData}
                              openAddModal={openAddSupplier}
                              addTitle={"Add Supplier"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Supplier Modal */}
                  <AddSupplier />
                  {/* Add Supplier Modal */}

                  {/* Edit Supplier Modal */}
                  <EditSupplier
                        {...supplierData}
                  />
                  {/* Edit Supplier Modal */}
            </>

      );
}
